import useJwt from '@src/auth/jwt/useJwt'

import { store } from '@store/storeConfig/store'

// ** Actions
import { setOrder } from '@src/views/apps/orders/store/actions'
import { handleLogout } from '@store/actions/auth'
import { setOriginContactFields } from '@store/actions/settings'

import {
  addProductToCart,
  clearCart,
  deleteProductFromCart,
  findProductInCart,
  getCart,
  renderToastError,
  renderToastSuccess,
  updateProductInCart
} from '@utils'
import {
  geSelectedProductsInLocalStorage,
  storageSelectedProducts,
  updateStorageSelectedProducts
} from '@src/utility/Utils'
import axios from 'axios'

// const productPrefix = '/brands/v2/products'
const orderPrefix = '/brands/v2/orders'
const categoryPrefix = '/brands/v2/categories'
const swagPacks = '/brands/v2/swag-packs'
useJwt.configLogout(store.dispatch, handleLogout)

// const proxyUrl = `http://localhost:3001`
const proxyUrl = `https://proxy.beuni.com.br`

const axiosProxy = axios.create({
  baseURL: proxyUrl
})

export const removeImage = (id) => {
  return (dispatch, getState) => {
    let checkout = { ...getState().ecommerce.checkout }

    dispatch({ type: 'UPDATE_CHECKOUT', data: { checkout: checkout } })
  }
}

export const setCompanyLogoError = (error) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_COMPANY_LOGO_ERROR',
      data: true
    })
  }
}

export const setImageCheckout = (imgs) => {
  return (dispatch, getState) => {
    const checkout = { ...getState().checkout }

    let company_logo = checkout.company_logo || []
    company_logo.push(...imgs.map((upload) => upload.uploadURL))

    let body = {
      uploads: imgs,
      client_email: checkout.client_email,
      price_deadline: checkout.price_deadline, // Prazo do cliente para ter o valor dos produtos
      shipping_deadline: checkout.shipping_deadline, // Prazo do cliente para entregar esses produtos
      company_logo: company_logo, // Logo da empresa/
      details: checkout.details, // Detalhes de requisitos
      use_our_logistics: checkout.use_our_logistics, // use_our_logistics

      extra_items: checkout.extra_items
    }

    dispatch({ type: 'SET_COMPANY_LOGO_ERROR', data: null })

    dispatch({
      type: 'UPDATE_CHECKOUT',
      data: {
        checkout: { ...checkout, company_logo }
      }
    })
  }
}
export const updateCheckout = (checkout) => {
  return (dispatch, getState) => {
    let body = {
      client_email: checkout?.client_email,
      client_phone: checkout?.client_phone,
      price_deadline: checkout.price_deadline, // Prazo do cliente para ter o valor dos produtos
      shipping_deadline: checkout.shipping_deadline, // Prazo do cliente para entregar esses produtos
      company_logo: checkout.company_logo, // Logo da empresa
      details: checkout.details, // Detalhes de requisitos
      use_our_logistics: checkout.use_our_logistics, // use_our_logistics
      extra_items: checkout.extra_items,
      outer_products: checkout.outer_products,
      address: checkout.address,
      coupon_id: checkout?.coupon_id ? checkout.coupon_id : ''
    }
    dispatch({ type: 'UPDATE_CHECKOUT', data: { checkout: body } })
  }
}

// ** POST Order and Line Items
export const createOrder = (history) => {
  return (dispatch, getState) => {
    const cart = getState().ecommerce.cart

    const lineItems = cart.map((cartItem) => ({
      name: cartItem.name,
      variation_id: cartItem.recordId,
      quantity: cartItem.qty,
      price: cartItem.price,
      observations: cartItem.observations || ' ',
      personalization: cartItem.personalization,
      personalization_id: cartItem.personalizationRecordId,
      personalization_image_url: cartItem.personalizationImageUrl,
      personalization_color: cartItem.personalizationColor,
      personalization_color_id: cartItem.personalizationColorId,
      brand_colors: cartItem.brandColors || 1
    }))

    const checkout = getState().ecommerce.checkout
    const origin = getState().ecommerce.origin

    const body = {
      client_email: checkout.client_email,
      client_phone: checkout.client_phone,
      price_deadline: checkout.price_deadline, // Prazo do cliente para ter o valor dos produtos
      shipping_deadline: checkout.shipping_deadline, // Prazo do cliente para entregar esses produtos
      company_logo: checkout.company_logo,
      details: checkout.details, // Detalhes de requisitos
      logistic_option: checkout.use_our_logistics,
      outer_products: checkout.outer_products,
      // ** Address
      ...checkout.address,

      // ** Coupon
      coupon_id: checkout?.coupon_id ? checkout.coupon_id : '',

      line_items: lineItems,
      extra_items: ' - ',
      origin
    }

    if (!body.shipping_deadline || !body.price_deadline) {
      return
    }
    return useJwt
      .atlasNoAuth()
      .post(orderPrefix, body)
      .then((res) => {
        clearCart()
        dispatch(deleteCart())
        dispatch(
          setOriginContactFields({
            email: checkout.client_email,
            phone: checkout.client_phone
          })
        )
        dispatch(setOrder(res.data))
        renderToastSuccess(`Recebemos seu ${res.data.title}!`)
        return res
      })
      .catch((err) => {
        renderToastError(
          'Houve um erro ao submeter o pedido. Por favor entre em contato conosco pelo chat.'
        )
        return err
      })
  }
}

// ** GET Products
export const getProducts = (params) => {
  return (dispatch) => {
    return axiosProxy
      .get('/api/products', { params })
      .then((res) => {
        // ** Different dispatchers, if origin is from new catalogue or not

        const isFromNewCatalogue = params?.kitManager

        if (isFromNewCatalogue) {
          const { products, total } = res.data

          dispatch({
            type: 'GET_CATALOGUE_V2_PRODUCTS',
            data: { products, total, params }
          })
        } else {
          dispatch({ type: 'GET_PRODUCTS', data: res.data, params })
        }
      })
  }
}

// ** GET Single Product
export const getProduct = (id, params) => {
  const [pId, variation] = id.split('/')
  return (dispatch) => {
    dispatch({ type: 'GET_PRODUCT_LOADING', data: { loading: true } })
    return axiosProxy
      .get('/api/product/' + pId, { params })
      .then((res) => {
        if (!res.data.product.id) {
          throw new Error('Produto não encontrado')
        }

        dispatch({ type: 'GET_PRODUCT_DETAIL', data: res.data })
      })
      .catch((err) => {
        dispatch({ type: 'GET_PRODUCT_DETAIL', data: { error: true } })
      })
      .finally(() => {
        dispatch({ type: 'GET_PRODUCT_LOADING', data: { loading: false } })
      })
  }
}

export const clearProduct = () => {
  return (dispatch) => {
    dispatch({ type: 'CLEAR_PRODUCT' })
  }
}

export const clearErrorsProduct = () => {
  return (dispatch) => {
    dispatch({ type: 'CLEAR_GET_PRODUCT_ERROR' })
  }
}

// ** GET Categories
export const getCategories = (params) => {
  return (dispatch) => {
    return axiosProxy.get('/api/categories', { params })
      .then((res) => {
        // ** Different dispatchers, if origin is from new catalogue or not
        const isFromNewCatalogue = params?.kitManager
        if (isFromNewCatalogue) {
          dispatch({ type: 'GET_CATALOGUE_V2_CATEGORIES', data: res.data })
        } else {
          dispatch({ type: 'GET_CATEGORIES', data: res.data })
        }
      })
      .catch((err) => {
        throw err
      })
  }
}

export const setCatalogueV2SelectedProducts = (products) => {
  return (dispatch) => {
    storageSelectedProducts(products)
    dispatch({ type: 'SET_CATALOGUE_V2_SELECTED_PRODUCTS', data: { products } })
  }
}

export const updateCatalogueV2SelectedProduct = (selectedProduct) => {
  return (dispatch, getState) => {
    const { selectedProducts } = getState().ecommerce.catalogueV2
    const draft = [...selectedProducts]
    const productIndex = draft.findIndex(
      (product) => product.id === selectedProduct.id
    )
    if (productIndex >= 0) {
      draft[productIndex] = { ...selectedProduct }

      updateStorageSelectedProducts(draft)
      dispatch({
        type: 'SET_CATALOGUE_V2_SELECTED_PRODUCTS',
        data: { products: draft }
      })
    }
  }
}

export const getStorageSelectedProducts = () => {
  return (dispatch) => {
    const selectedProducts = geSelectedProductsInLocalStorage()

    if (selectedProducts) {
      dispatch({
        type: 'SET_CATALOGUE_V2_SELECTED_PRODUCTS',
        data: { products: selectedProducts }
      })
    }
  }
}

export const updateCatalogueV2ProductAmount = (productId, amount) => {
  return (dispatch, getState) => {
    const { selectedProducts, packAmount } = getState().ecommerce.catalogueV2
    const draft = [...selectedProducts]
    const productIndex = draft.findIndex((product) => product.id === productId)
    if (productIndex >= 0) {
      // draft[productIndex].perPackAmount = packAmount
      draft[productIndex].amount = amount

      updateStorageSelectedProducts(draft)
      dispatch({
        type: 'UPDATE_CATALOGUE_V2_PRODUCT_AMOUNT',
        data: { selectedProducts: draft }
      })
    }
  }
}

export const updateCatalogueV2ProductSelectedItems = (items) => {
  return (dispatch, _) => {
    localStorage.setItem('selectedProducts', JSON.stringify(items))
    dispatch({
      type: 'UPDATE_CATALOGUE_V2_PRODUCT_AMOUNT',
      data: { selectedProducts: items }
    })
  }
}

export const updateCatalogueV2PackAmount = (packAmount) => {
  return (dispatch, getState) => {
    const { selectedProducts } = getState().ecommerce.catalogueV2
    const updatedAmountProducts = selectedProducts.map((product) => {
      return { ...product, amount: product.perPackAmount * packAmount }
    })
    dispatch({
      type: 'UPDATE_CATALOGUE_V2_PACK_AMOUNT',
      data: { packAmount, selectedProducts: updatedAmountProducts }
    })
  }
}

// ** GET Cart Items
export const getCartItems = () => {
  return (dispatch) => {
    dispatch({ type: 'GET_CART', data: { cart: getCart() } })
  }
}
// ** DELETE Cart Items
export const deleteCart = (id) => {
  return (dispatch) => {
    const cart = []

    dispatch({ type: 'OVERRIDE_CART', data: { cart } })
    dispatch(getCartItems())
  }
}

// ** Add Item to Cart
export const addToCart = ({
  id,
  quantity,
  personalizationId,
  personalizationRecordId,
  personalizationImageUrl,
  personalizationColorName,
  personalizationColorId,
  kitManager
}) => {
  return (dispatch, getState) => {
    let productData = getState().ecommerce.productDetail

    // ** data Receives kitManager if it's from new catalogue
    if (kitManager) {
      // ** Provisório, para trazer o produto pai
      productData = kitManager
      dispatch({
        type: 'SET_ORDER_ORIGIN',
        data: { origin: 'dashboard - kit creator' }
      })
    } else {
      dispatch({ type: 'SET_ORDER_ORIGIN', data: { origin: 'dashboard' } })
    }

    if (productData.variations && !kitManager) {
      const aux = productData.variations.find(
        (variation) => variation.record_id === id
      )
      productData = { ...productData, ...aux }
    }

    productData.recordId =
      productData.kitManagerVariations ?? productData.record_id
    productData.name = productData.public_id ?? productData.name
    if (productData.price === undefined) {
      productData.price = productData['Preço unitário estimado']
    }

    productData.id = String(productData.id)
    // data.id = aux.product_sku_part[0] + '/' + aux.public_id
    // data.slug = aux.product_sku_part[0]

    const newItem = {
      ...productData,
      qty: quantity
    }

    // ** Selected personalization fields

    if (personalizationId) newItem.personalization = personalizationId
    if (personalizationRecordId)
      newItem.personalizationRecordId = personalizationRecordId
    if (personalizationImageUrl)
      newItem.personalizationImageUrl = personalizationImageUrl
    if (personalizationColorName)
      newItem.personalizationColor = personalizationColorName
    if (personalizationColorId)
      newItem.personalizationColorId = personalizationColorId

    const item = findProductInCart(productData.record_id)
    let cart
    if (!item) {
      cart = addProductToCart(newItem)
    } else {
      cart = updateProductInCart({
        ...newItem,
        qty: newItem.qty,
        personalization: newItem.personalization,
        personalizationRecordId: newItem.personalizationRecordId,
        personalizationImageUrl: newItem.personalizationImageUrl,
        personalizationColor: newItem.personalizationColor,
        personalizationColorId: newItem.personalizationColorId
      })
    }

    if (cart) {
      dispatch({
        type: 'OVERRIDE_CART',
        data: {
          cart
        }
      })
    }

    return newItem
  }
}
export const addSwagPackToProductDetail = (swagPack) => {
  return (dispatch, getState) => {
    let data = swagPack

    if (data) {
      dispatch({
        type: 'SELECT_SWAG_PACK',
        data: {
          productDetail: data
        }
      })
    }
  }
}
// ** Update Item in Cart
export const updateInCart = (data) => {
  return (dispatch) => {
    const cart = updateProductInCart(data)

    if (cart) {
      dispatch({
        type: 'OVERRIDE_CART',
        data: {
          cart
        }
      })
    }
  }
}

// ** GET Wishlist Items
export const getWishlistItems = () => {
  return (dispatch) => {
    return useJwt
      .atlas()
      .get('/apps/ecommerce/wishlist')
      .then((res) => {
        dispatch({ type: 'GET_WISHLIST', data: res.data })
      })
  }
}

// ** DELETE Wishlist Item
export const deleteWishlistItem = (id) => {
  return (dispatch) => {
    return useJwt
      .atlas()
      .delete(`/apps/ecommerce/wishlist/${id}`)
      .then((res) => {
        dispatch({ type: 'DELETE_WISHLIST_ITEM', data: res.data })
        dispatch(getWishlistItems())
      })
  }
}

// ** Add Item to Wishlist
export const addToWishlist = (id) => {
  return (dispatch) => {
    return useJwt
      .atlas()
      .post('/apps/ecommerce/wishlist', { productId: id })
      .then(() => {
        dispatch({ type: 'ADD_TO_WISHLIST' })
      })
  }
}

// ** DELETE Cart Items
export const deleteCartItem = (id) => {
  return (dispatch) => {
    const cart = deleteProductFromCart(id)

    if (cart) {
      dispatch({ type: 'OVERRIDE_CART', data: { cart } })
      dispatch(getCartItems())
    }
  }
}

// ** DELETE Cart Items
export const getSwagPacks = (params) => {
  return (dispatch) => {
    return useJwt
      .atlas()
      .get(swagPacks + '?load=variations', { ...params, load: 'variations' })
      .then((res) => {
        dispatch({
          type: 'GET_SWAG_PACKS',
          data: { ...res.data },
          params
        })
      })
  }
}
